import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Graph from './graphTable';
import Bar from './bar';
import BarBPM from './barBPM';
import Message from '../common/message';
import utilFunction from '../../containers/function';

const validateDate = (filter, date) => {
  let dateValue;
  if (filter) {
    dateValue = filter;
  } else if (date) {
    dateValue = date.substring(0, 10);
  } else {
    dateValue = new Date();
  }
  return dateValue;
};

const arrow = type => {
  let text;
  if (type.toUpperCase() === 'INCREASE') {
    text = <i className="fas fa-arrow-up" />;
  } else if (type.toUpperCase() === 'DECREASE') {
    text = <i className="fas fa-arrow-down" />;
  } else if (type.toUpperCase() === 'NONE') {
    text = <i className="fas fa-minus" />;
  }
  return text;
};

// function created for severity
const colorSeverityItem = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return 'gris';
  } else if (severety.toUpperCase() === 'BAD' || severety.toUpperCase() === 'WORSE') {
    return 'red';
  } else if (severety.toUpperCase() === 'GOOD' || severety.toUpperCase() === 'BETTER') {
    return 'green';
  } else if (severety.toUpperCase() === 'SAME') {
    return 'gris';
  }
  return 'yellow';
};

const colorSeverityText = severety => {
  // condition to define the color as defined in the api
  if (severety == null) {
    return '';
  } else if (severety.toUpperCase() === 'BAD' || severety.toUpperCase() === 'WORSE') {
    return 'peor respecto al período anterior';
  } else if (severety.toUpperCase() === 'GOOD' || severety.toUpperCase() === 'BETTER') {
    return 'mejor respecto al período anterior';
  } else if (severety.toUpperCase() === 'SAME') {
    return `No hay cambios con respecto al período anterior`;
  }
  return '';
};

// function that helps to render the trend of the cells
const renderTrend = (trend, type, actual, previous, differenceValue, language) => {
  if (type!=null && trend!=null && trend.toUpperCase() === 'BETTER') {
    return (
    <span className={colorSeverityItem(trend.toUpperCase()) + " difference-icon"}>
      {arrow(type)}
      <div className="modal-indicators-info right">
        <a>
          <i className="fas fa-question-circle" />
          <div>
            <h6 className={colorSeverityItem(trend.toUpperCase())}>
              {differenceValue}% {colorSeverityText(trend.toUpperCase())}
            </h6>
            <p>
              {language.summary.nfa.before} ({previous ? moment(previous.start).format('DD-MM') : '-'}{' '}
              {language.summary.nfa.to} {previous ? moment(previous.end).format('DD-MM') : '-'}){' '}
              <span className={colorSeverityItem(previous ? previous.type : null)}>
                {previous ? `${previous.value}%` : '0%'}
              </span>
            </p>
            <p>
              {language.summary.nfa.now} ({moment(actual.start).format('DD-MM')} al{' '}
              {moment(actual.end).format('DD-MM')}):{' '}
              <span className={colorSeverityItem(actual.type)}>{actual.value}%</span>
            </p>
          </div>
        </a>
      </div>
    </span>
    );
  } else if (type!=null && trend!=null && trend.toUpperCase() === 'WORSE') {
    return (
    <span className={colorSeverityItem(trend.toUpperCase()) + " difference-icon"}>
      {arrow(type)}
      <div className="modal-indicators-info right">
        <a>
          <i className="fas fa-question-circle" />
          <div>
            <h6 className={colorSeverityItem(trend.toUpperCase())}>
              {differenceValue}% {colorSeverityText(trend.toUpperCase())}
            </h6>
            <p>
              {language.summary.nfa.before} ({previous ? moment(previous.start).format('DD-MM') : '-'}{' '}
              {language.summary.nfa.to} {previous ? moment(previous.end).format('DD-MM') : '-'}){' '}
              <span className={colorSeverityItem(previous ? previous.type : null)}>
                {previous ? `${previous.value}%` : '0%'}
              </span>
            </p>
            <p>
              {language.summary.nfa.now} ({moment(actual.start).format('DD-MM')} al{' '}
              {moment(actual.end).format('DD-MM')}):{' '}
              <span className={colorSeverityItem(actual.type)}>{actual.value}%</span>
            </p>
          </div>
        </a>
      </div>
    </span>
    );
  } else if (type!=null && trend!=null && trend.toUpperCase() === 'SAME') {
    return (
    <span className={colorSeverityItem(trend.toUpperCase()) + " difference-icon"}>
      {arrow(type)}
      <div className="modal-indicators-info right">
        <a>
          <i className="fas fa-question-circle" />
          <div>
            <h6 className={colorSeverityItem(trend.toUpperCase())}>
              {differenceValue}% {colorSeverityText(trend.toUpperCase())}
            </h6>
            <p>
              {language.summary.nfa.before} ({previous ? moment(previous.start).format('DD-MM') : '-'}{' '}
              {language.summary.nfa.to} {previous ? moment(previous.end).format('DD-MM') : '-'}){' '}
              <span className={colorSeverityItem(previous ? previous.type : null)}>
                {previous ? `${previous.value}%` : '0%'}
              </span>
            </p>
            <p>
              {language.summary.nfa.now} ({moment(actual.start).format('DD-MM')} al{' '}
              {moment(actual.end).format('DD-MM')}):{' '}
              <span className={colorSeverityItem(actual.type)}>{actual.value}%</span>
            </p>
          </div>
        </a>
      </div>
    </span>
    );
  }
  return <span />;
};

const Table = props => (
  <div className="module-table top">
    <table>
      <thead>
        <tr>
          <th className="th150 center">
            <a
              role="button"
              data-type="alias"
              tabIndex={0}
              onClick={props.handleSort}
              className="th100 helpsortth"
            >
              {props.main=="1" ? props.language.filter.workShiftGroup : 
                props.language.filter[props.main.toLowerCase()]}{' '}
              <div className="sort-icons">
                <div className="sort-icons-inner">
                  <i className={"fas fa-caret-up " + 
                    (props.sort["alias"]=="ASC" ? "active" : "")}/>
                  <i className={"fas fa-caret-down " + 
                    (props.sort["alias"]=="DESC" ? "active" : "")}/>
                </div>
              </div>
              <div className="modal-indicators-info">
                <a>
                  <i className="fas fa-question-circle" />
                  <div>
                    <p>{props.language.summary.ffdSleep[props.reportType].categoryHelp}</p>
                  </div>
                </a>
              </div>
            </a>
          </th>
          <th className="th100 center">
            <a
              role="button"
              data-type="ndrivers"
              tabIndex={0}
              onClick={props.handleSort}
              className="th100 helpsortth"
            >
              {props.language.summary.ffdSleep[props.reportType].driverNumber}
              <div className="sort-icons">
                <div className="sort-icons-inner">
                  <i className={"fas fa-caret-up " + 
                    (props.sort["ndrivers"]=="ASC" ? "active" : "")}/>
                  <i className={"fas fa-caret-down " + 
                    (props.sort["ndrivers"]=="DESC" ? "active" : "")}/>
                </div>
              </div>
              <div className="modal-indicators-info">
                <a>
                  <i className="fas fa-question-circle" />
                  <div>
                    <p>{props.language.summary.ffdSleep[props.reportType].driverNumberHelp}</p>
                  </div>
                </a>
              </div>            
            </a>
          </th>
          <th className="th150 center">
            <a role="button" className="helpsortth" data-type="ninRisk" tabIndex={0} onClick={props.handleSort}>
              {props.language.summary.ffdSleep[props.reportType].atRisk}
              <br/>
              {"(" +
                (utilFunction.getFormatFunction(
                  {type:"PARSE_DATE_STRING",format:["%d-%m-%Y","%Y-%m-%d"]}
                ))(validateDate(props.filters.date.fechaEndFinal, props.date.response.maxDate))+")"}
              <div className="sort-icons">
                <div className="sort-icons-inner">
                  <i className={"fas fa-caret-up " + 
                    (props.sort["ninRisk"]=="ASC" ? "active" : "")}/>
                  <i className={"fas fa-caret-down " + 
                    (props.sort["ninRisk"]=="DESC" ? "active" : "")}/>
                </div>
              </div>
              <div className="modal-indicators-info">
                <a>
                  <i className="fas fa-question-circle" />
                  <div>
                    <p>{props.language.summary.ffdSleep[props.reportType].atRiskHelp.replace("dd-mm-yyyy",
                    (utilFunction.getFormatFunction(
                      {type:"PARSE_DATE_STRING",format:["%d-%m-%Y","%Y-%m-%d"]}
                    ))(validateDate(props.filters.date.fechaEndFinal, props.date.response.maxDate))
                  )}</p>
                  </div>
                </a>
              </div>
            </a>
          </th>
          <th className="th150 center">
            <a role="button" className="helpsortth" data-type="risk" tabIndex={0} onClick={props.handleSort}>
              {props.language.summary.ffdSleep[props.reportType].riskPeriod}
              <div className="sort-icons">
                <div className="sort-icons-inner">
                  <i className={"fas fa-caret-up " + 
                    (props.sort["risk"]=="ASC" ? "active" : "")}/>
                  <i className={"fas fa-caret-down " + 
                    (props.sort["risk"]=="DESC" ? "active" : "")}/>
                </div>
              </div>
              <div className="modal-indicators-info">
                <a className="green">
                  <i className="fas fa-question-circle" />
                  <div>            
                    <p>{props.language.summary.ffdSleep[props.reportType].indicatorHelp1}</p>
                    <p>{props.language.summary.ffdSleep[props.reportType].indicatorHelp2}</p>
                    <p>
                      <span className="green">
                      {props.language.summary.ffdSleep[props.reportType].labelRate + " " + props.language.summary.graphTooltip.GOOD + ": "}
                      </span> 
                      {props.language.summary.ffdSleep[props.reportType].between + " " + props.ffd.graphRange.good[0] + "% a " + props.ffd.graphRange.good[1] +"%"}
                    </p>
                    <p>
                      <span className="yellow">
                      {props.language.summary.ffdSleep[props.reportType].labelRate + " " + props.language.summary.graphTooltip.MEDIUM + ": "}
                      </span> 
                      {props.language.summary.ffdSleep[props.reportType].between + " " + (props.ffd.graphRange.medium[0]+1) + "% a " + props.ffd.graphRange.medium[1] +"%"}
                    </p>
                    <p>
                      <span className="red">
                      {props.language.summary.ffdSleep[props.reportType].labelRate + " " + props.language.summary.graphTooltip.BAD + ": "}
                      </span> 
                      {props.language.summary.ffdSleep[props.reportType].between + " " + (props.ffd.graphRange.bad[0]+1) + "% a 100%"}
                    </p>
                  </div>
                </a>
              </div>
            </a>
          </th>
          <th className="center">
            <a role="button" className="helpsortth" data-type="evolution" tabIndex={0} onClick={props.handleSort}>
              {props.language.summary.ffdSleep[props.reportType].driversAtRisk}
              <div className="sort-icons">
                <div className="sort-icons-inner">
                  <i className={"fas fa-caret-up " + 
                    (props.sort["evolution"]=="ASC" ? "active" : "")}/>
                  <i className={"fas fa-caret-down " + 
                    (props.sort["evolution"]=="DESC" ? "active" : "")}/>
                </div>
              </div>
              <div className="modal-indicators-info">
                  <a className="green">
                    <i className="fas fa-question-circle" />
                    <div>            
                      <p>{props.language.summary.ffdSleep[props.reportType].evHelp1}</p>
                      <p>{props.language.summary.ffdSleep[props.reportType].evHelp2.replace("dd-mm-yyyy",
                          (utilFunction.getFormatFunction(
                            {type:"PARSE_DATE_STRING",format:["%d-%m-%Y","%Y-%m-%d"]}
                          ))(validateDate(props.filters.date.fechaEndFinal, props.date.response.maxDate))
                        )}
                      </p>
                      <p>
                        <span className="green">
                        {props.language.summary.ffdSleep[props.reportType].labelRate + " " + props.language.summary.graphTooltip.GOOD + ": "}
                        </span> 
                        {props.language.summary.ffdSleep[props.reportType].between + " " + props.ffd.graphRange.good[0] + "% a " + props.ffd.graphRange.good[1] +"%"}
                      </p>
                      <p>
                        <span className="yellow">
                        {props.language.summary.ffdSleep[props.reportType].labelRate + " " + props.language.summary.graphTooltip.MEDIUM + ": "}
                        </span> 
                        {props.language.summary.ffdSleep[props.reportType].between + " " + (props.ffd.graphRange.medium[0]+1) + "% a " + props.ffd.graphRange.medium[1] +"%"}
                      </p>
                      <p>
                        <span className="red">
                        {props.language.summary.ffdSleep[props.reportType].labelRate + " " + props.language.summary.graphTooltip.BAD + ": "}
                        </span> 
                        {props.language.summary.ffdSleep[props.reportType].between + " " + (props.ffd.graphRange.bad[0]+1) + "% a 100%"}
                      </p>
                    </div>
                  </a>
                </div>            
            </a>
          </th>
          <th className="center">
            <a role="button" className="helpsortth" data-type="distribution" tabIndex={0} onClick={props.handleSort}>
              {props.language.summary.ffdSleep[props.reportType].riskDistribution}
              <div className="sort-icons">
                <div className="sort-icons-inner">
                  <i className={"fas fa-caret-up " + 
                    (props.sort["distribution"]=="ASC" ? "active" : "")}/>
                  <i className={"fas fa-caret-down " + 
                    (props.sort["distribution"]=="DESC" ? "active" : "")}/>
                </div>
              </div>
              <div className="modal-indicators-info">
                <a className="green">
                  <i className="fas fa-question-circle" />
                  <div>            
                    <p>{props.language.summary.ffdSleep[props.reportType].distHelp1}</p>
                    {props.language.summary.ffdSleep[props.reportType].cat1Label && (
                      <p>
                        <span className="green">
                        {props.language.summary.ffdSleep[props.reportType].cat1Label + ": "}
                        </span> 
                        {props.language.summary.ffdSleep[props.reportType].cat1}
                      </p>
                    )}
                    {props.language.summary.ffdSleep[props.reportType].cat2Label && (
                      <p>
                        <span className="yellow">
                        {props.language.summary.ffdSleep[props.reportType].cat2Label + ": "}
                        </span> 
                        {props.language.summary.ffdSleep[props.reportType].cat2}
                      </p>
                    )}
                    {props.language.summary.ffdSleep[props.reportType].cat3Label && (
                      <p>
                        <span className="red">
                        {props.language.summary.ffdSleep[props.reportType].cat3Label + ": "}
                        </span> 
                        {props.language.summary.ffdSleep[props.reportType].cat3}
                      </p>
                    )}
                    {props.language.summary.ffdSleep[props.reportType].cat4Label && (
                      <p>
                        <span className="purple">
                        {props.language.summary.ffdSleep[props.reportType].cat4Label + ": "}
                        </span> 
                        {props.language.summary.ffdSleep[props.reportType].cat4}
                      </p>
                    )}
                  </div>
                </a>
              </div>
            </a>
          </th>
          <th className="center">
            <a className="noLink helpsortth">
              {props.language.summary.ffdSleep[props.reportType].deviationDitribution}
              <div className="modal-indicators-info left">
                <a className="green">
                  <i className="fas fa-question-circle" />
                  <div>            
                    <p>{props.language.summary.ffdSleep[props.reportType].desvHelp1}</p>
                    {props.language.summary.ffdSleep[props.reportType].desvCat1Label && (
                      <p>
                        <span className="green">
                        {props.language.summary.ffdSleep[props.reportType].desvCat1Label}
                        </span>
                      </p>
                    )}
                    {props.language.summary.ffdSleep[props.reportType].desvCat2Label && (
                      <p>
                        <span className="yellow">
                        {props.language.summary.ffdSleep[props.reportType].desvCat2Label}
                        </span>
                      </p>
                    )}
                    {props.language.summary.ffdSleep[props.reportType].desvCat3Label && (
                      <p>
                        <span className="red">
                        {props.language.summary.ffdSleep[props.reportType].desvCat3Label}
                        </span>
                      </p>
                    )}
                    {props.language.summary.ffdSleep[props.reportType].desvCat4Label && (
                      <p>
                        <span className="purple">
                        {props.language.summary.ffdSleep[props.reportType].desvCat4Label}
                        </span>
                      </p>
                    )}
                  </div>
                </a>
              </div>
            </a>
          </th>
        </tr>
      </thead>
      <tbody>
        {props.datos.map((item, i) => {
          return item.ndrivers==null ? (
            <tr
              key={`${i}`}
              data-datos={JSON.stringify(item)}
              className="hover"
            >
              {/* Name */}
              <td className="first">
                <div className="td-alias">
                  <span className={`${colorSeverityItem(item.kpi.value.type)} font16`} />
                  <div>{item.alias}</div>
                </div>
              </td>
              <td className="center" colSpan={6}>
                <p className="red center">{props.language.summary.ffdSleep.noDataAvailable}</p>
              </td>
            </tr>
          ) : (
            <tr
              key={`${i}`}
              data-datos={JSON.stringify(item)}
              className="hover"
            >
              {/* Name */}
              <td className="first">
                <div className="td-alias">
                  <span className={`${colorSeverityItem(item.kpi.value.type)} font16`} />
                  <div>{item.alias}</div>
                </div>
              </td>
              <td className="right">{item.ndrivers}</td>
              <td className="right">{item.driverWithBadKpi}</td>
              {/* Average Risk */}
              <td className="center td-avg">
                <div className="avg">
                  {
                    <span className={colorSeverityItem(item.kpi.value.type) + " bigIndicator"}>
                      {item.kpi.value.value!=null ? item.kpi.value.value+"%" : ""}
                    </span>
                  }
                  {renderTrend(
                    item.kpi.difference.trend,
                    item.kpi.difference.type,
                    item.kpi.value,
                    item.kpi.previousValue,
                    item.kpi.difference.value,
                    props.language
                  )}

                  <span className="absolute difference-avg">
                    <p className={colorSeverityItem(item.kpi.difference.trend)}>
                      {(item.kpi.difference.value!=null) ? `${item.kpi.difference.value}%` : ''}
                    </p>
                  </span>
                </div>
              </td>
              <td className="center">
                <div className="flex align-center">
                  <div className="graph-table">
                    <Graph
                      tooltip={props.language}
                      graphColorRange={props.ffd.graphRange}
                      data={item.evolution}
                      id={`graph-${i}`}
                      reportType={props.reportType}
                      period={item.period}
                    />
                  </div>
                  <div className="graph-table-indicator">
                    {item.evolution.length > 0 ? (
                      <p
                        className={colorSeverityItem(
                          item.evolution[item.evolution.length - 1].type
                        )}
                      >
                        {' '}
                        {item.evolution[item.evolution.length - 1].value!=null ? 
                          item.evolution[item.evolution.length - 1].value + "%" :
                          ""
                        }
                      </p>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </td>
              <td className="center">
                <Bar 
                  distribution={item.distribution} 
                  language={props.language}
                  reportType={props.reportType}
                />
              </td>
              <td className="center">
                {((item.key in props.BPM) 
                  && props.BPM[item.key]!=null 
                  && props.BPM[item.key].length>0) && (
                  <BarBPM
                    distribution={props.BPM[item.key]}
                    title={props.title}
                    language={props.language}
                    reportType={props.reportType}
                  />
                )}
                {((item.key in props.BPM) 
                  && props.BPM[item.key]!=null 
                  && props.BPM[item.key].length==0) && (
                  <p className="center">{props.language.summary.ffdSleep.noDevs}</p>
                )}
                {(item.key in props.BPM) 
                  && props.BPM[item.key]==null && (
                  <p className="red center">{props.language.summary.ffdSleep.apiError}</p>
                )}
                {(props.loadingBPM && !(item.key in props.BPM)) && (
                  <div className="loading-td">
                    <i className="fas fa-spinner fa-pulse" />
                  </div>
                )} 
              </td>
            </tr>
          )
        })}
      </tbody>
    </table>
    {props.loadingTable && (
      <div className="loading-table">
        <h6>
          <i className="fas fa-spinner fa-spin" />
        </h6>
      </div>
    )}
    {props.pag >= props.count.pages && (
      <div className="loading-table">
        <h6>{props.language.summary.nfa.noData}</h6>
      </div>
    )}
  </div>
);

Table.propTypes = {
  pag: PropTypes.number.isRequired,
  count: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  loadingTable: PropTypes.bool.isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired,
  datos: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ]).isRequired
};

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/summary_ffd_sleep/table.jsx